export default __webpack_public_path__ + "static/media/yammie.b8c3196a.webp";